export default {
  viewBox: "0 0 24 24",
  html: "<path fill=\"#202426\" fill-rule=\"evenodd\" d=\"M12.32 6c-3.3 0-6 2.7-6 6h3l-4 4-4-4h3c0-4.4 3.6-8 8-8 1.6 0 3 .5 4.3 1.2l-1.5 1.5c-.8-.5-1.8-.7-2.8-.7m3 6 4-4 4 4h-3c0 4.4-3.6 8-8 8-1.6 0-3-.5-4.3-1.2l1.5-1.5c.8.5 1.8.7 2.8.7 3.3 0 6-2.7 6-6z\" clip-rule=\"evenodd\"/>"
};